import React, { Fragment } from "react";
import Spinner from "../../../common/spinner";
import "./ButtonGroup.style.scss";

const ButtonGroup = (props) => {
  const {
    blockSubmit,
    addHandler,
    removeHandler,
    saveHandler,
    saveMessage,
    postingDatafailed,
    spinner,
  } = props;
  return (
    <Fragment>
      {postingDatafailed ? (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            margin: "10px 0",
          }}
        >
          Could not persist My Universe settings. Using My Universe for this
          session. Error Code : 405
        </div>
      ) : postingDatafailed == false && saveMessage ? (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            margin: "10px 0",
          }}
        >
          Your Universe of Securities have been Saved.
        </div>
      ) : null}
      <div className="myUniverse_buttonGroup">
        <div>
          <button className="btn mr5" onClick={(e) => addHandler(e)}>
            Add
          </button>
          <button className="btn" onClick={() => removeHandler()}>
            Remove
          </button>
        </div>

        <div>
          <button
            className="btn"
            disabled={blockSubmit}
            onClick={(e) => saveHandler(e)}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            save &nbsp;
            {postingDatafailed == false && spinner ? (
              <Spinner size="small" />
            ) : null}
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/components/pages/MyUniverse/buttonGroup/ButtonGroup.jsx